import React, { Component } from 'react'

class ImageContentContent extends Component {

  render() {
    const { image, leftContent, rightContent } = this.props

    return (
      <section className='image-content-content' data-color="#FFFFFF" id="about-the-area">
        <div className="image-content-content__inner">
          <div className='image-content-content__wrapper'>
            <img src={image.localFile.publicURL} alt='WHITEFOX Realestate' />
            <div className='image-content-content__content'>
              <div dangerouslySetInnerHTML={{ __html: leftContent }} />
              <div dangerouslySetInnerHTML={{ __html: rightContent }} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default ImageContentContent